export const calculateIncTaxPrice = (exTaxPrice: number, taxRate?: number) => {
  const localTaxRate = taxRate ?? 0;

  return localTaxRate > 0
    ? Math.round((exTaxPrice / (1 + localTaxRate / 100)) * 100) / 100
    : exTaxPrice;
};
